/**
 * #2297: assistant markdown can carry an in-app link (e.g. /artifacts/:id for
 * a gadget). App pages stay in the SPA; Worker API links (including file
 * downloads) and external links use native browser navigation. This is
 * the one `a` renderer both chat surfaces (DataAnalyst.tsx, AnalystPanel.tsx)
 * use in their react-markdown `components` prop, so the two never drift.
 */
import type { ComponentProps } from "react";
import { Link as RouterLink } from "react-router";

/** Same-origin app paths only; /api belongs to the Worker, not the SPA. */
function isInternalPath(href: string | undefined): href is string {
  return !!href && href.startsWith("/") && !href.startsWith("//") && !/^\/api(?:\/|[?#]|$)/.test(href);
}

export function MarkdownLink({ children, href, className, ...props }: ComponentProps<"a">) {
  const cls = className ?? "text-primary underline underline-offset-2";
  if (isInternalPath(href)) {
    return (
      <RouterLink to={href} className={cls} {...props}>
        {children}
      </RouterLink>
    );
  }
  return (
    <a className={cls} href={href} target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </a>
  );
}
